import { Component, OnInit, Input } from '@angular/core'
import * as $ from 'jquery'
import { AjaxService } from 'src/app/shared/ajax.service'
import { PmodalModel } from './pmodal.model'
import { PmodalService } from './pmodal.service'
import { PageModel, PagesumModel } from '../../page/page.model'

@Component({
  selector: 'app-pmodal',
  templateUrl: './pmodal.component.html'
})
export class PmodalComponent implements OnInit {
  @Input() model: PmodalModel
  pageId: number
  pageModel: PageModel
  layout: PagesumModel[][]

  constructor(public service: PmodalService, private ajax: AjaxService) { }

  ngOnInit() {
    var thos = this
    $('#pmodal').on('hidden.bs.modal', function () {
      thos.service.unimplement()
    })
  }

  ExecutePartial = function (option) {
    this.Open();
    this.onclosed = null;
    if (option.befor != undefined) option.befor();
    if (option.onclosed != undefined) this.onclosed = option.onclosed;
    if (option.width != undefined) this.modal.find('.modal-dialog').css('width', option.width);
    this.header.find('.loading').show();
    this.title.html(option.title);
    this.descript.html(option.descript == undefined ? '' : option.descript);
    option.alertPad = { pad: 'toastr', mode: 'text', display: 'inline-block' },
      option.success = function () {
        var masterHeader = '';
        if (option.masterHeader) {
          for (var i = 0; i < option.masterHeader.length; i++)
            masterHeader += '<strong>' + option.masterHeader[i][0] + '</strong> : &nbsp;<span>' + option.masterHeader[i][1] + '</span> &nbsp; &nbsp; &nbsp;';

          this.masterHeader = masterHeader
        }
      }
    option.complete = function () {
      this.header.find('.loading').hide();
    }

    this.ajax.execute(option);
  }

  Document = function (title: string, html: string, option: any) {
    if (!option) option = {};

    if (option.width) this.modal.find('.modal-dialog').css('width', option.width)
    this.title = title
    this.content.html(html)
    if (option.masterHeader)
      this.masterHeader = option.masterHeader
    else
      this.masterHeader = ''
  }

  condition_gridform(mdl: any, mod: number) {
    if (mdl.ctyp != 'grid') return false
    let r
    if (mod == 1) r = mdl.dis == 2
    else if (mod == 2) r = mdl.disf == 2
    else if (mod == 3) r = mdl.dis == 4
    else if (mod == 4) r = mdl.disf == 4
    return r
  }

  is_array(mdl: any) {
    return Array.isArray(mdl)
  }
}
